import { render, staticRenderFns } from "./vendor-business-details.vue?vue&type=template&id=8390d31e&scoped=true"
import script from "./vendor-business-details.vue?vue&type=script&lang=js"
export * from "./vendor-business-details.vue?vue&type=script&lang=js"
import style0 from "./vendor-business-details.vue?vue&type=style&index=0&id=8390d31e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8390d31e",
  null
  
)

export default component.exports